import { CalendarActions } from './actions'
import { CalendarGetters } from './getters'
import { CalendarMutations } from './mutations'
import { CalendarState } from './state'

export const CALENDAR_NAMESPACE = 'calendar'

export const Calendar = {
  actions: CalendarActions,
  getters: CalendarGetters,
  mutations: CalendarMutations,
  namespaced: true,
  state: CalendarState,
}
